import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { Tooltip } from '@/components/ui/Tooltip';

export interface InfoHintProps {
  content: ReactNode;
  label: string;
}

/**
 * A small info icon that reveals explanatory content in a tooltip on hover
 * or keyboard focus. Extracted from the inline icon-plus-Tooltip markup
 * `RefundReasonHint.tsx` used first, promoted here on its second call site
 * (Team Access permission columns) per mnr-standards' reuse-or-create rule.
 */
export function InfoHint({ content, label }: InfoHintProps) {
  return (
    <Tooltip content={content}>
      <button
        type="button"
        aria-label={label}
        className="text-text-muted hover:text-text-primary focus-visible:ring-accent inline-flex cursor-help rounded-full focus-visible:ring-2 focus-visible:outline-none"
      >
        <Info aria-hidden="true" className="h-4 w-4" />
      </button>
    </Tooltip>
  );
}
